export const withLayout = ({ theme, ...props }) => {
    const rules = {};
    if (props.flexBasis) {
        rules.flexBasis = props.flexBasis;
    }
    if (props.flexGrow) {
        rules.flexGrow = props.flexGrow;
    }
    if (props.flexShrink) {
        rules.flexShrink = props.flexShrink;
    }
    if (props.gridColumnSpan !== undefined) {
        rules.gridColumn = `span ${props.gridColumnSpan} / span ${props.gridColumnSpan}`;
    }
    if (props.gridRowSpan !== undefined) {
        rules.gridRow = `span ${props.gridRowSpan} / span ${props.gridRowSpan}`;
    }
    if (props.gridArea) {
        rules.gridArea = props.gridArea;
    }
    return rules;
};
